export const groupDataByProperty = (data, property) => {
  return data.reduce((groups, item) => {
    const itemProperty = item[property];
    if (!groups[itemProperty]) {
      groups[itemProperty] = [];
    }
    groups[itemProperty].push(item);
    return groups;
  }, {});
};
